import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-lookers py-24 text-center" data-testid="not-found-page">
      <h1 className="font-serif text-5xl mb-4 text-zinc-900">
        Page Not Found
      </h1>
      <Link to="/" className="underline text-sm text-teal-700">Return home</Link>
    </div>
  );
}
